import React, { useState } from 'react';
import './SupportPortal.scss';
import logo from '../../img/avionica.png';
import { API_URL } from './api';
import StatsTab from './tabs/StatsTab';
import CustomersTab from './tabs/CustomersTab';
import SerialsTab from './tabs/SerialsTab';
import LogsTab from './tabs/LogsTab';
import PocketReaderLogsTab from './tabs/PocketReaderLogsTab';
import FaqTab from './tabs/FaqTab';

const TABS = [
  { key: 'stats',            label: 'Statistics' },
  { key: 'customers',        label: 'Customers' },
  { key: 'serials',          label: 'S/N Units' },
  { key: 'logs',             label: 'Back End Logs' },
  { key: 'pocketreaderlogs', label: 'pocketReader Logs' },
  { key: 'faq',              label: 'FAQ' },
];
const TOKEN_KEY = 'supportToken';
const USER_KEY  = 'supportUser';

const SupportPortal = () => {
  // Token persists in sessionStorage so a reload doesn't force re-login. Cleared
  // on explicit logout and on any 401 (onAuthFail).
  const [token, setToken]         = useState(() => sessionStorage.getItem(TOKEN_KEY));
  const [loggedInAs, setLoggedInAs] = useState(() => sessionStorage.getItem(USER_KEY) || '');
  const [activeTab, setActiveTab] = useState('stats');

  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError]       = useState('');
  const [signingIn, setSigningIn]         = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError(''); setSigningIn(true);
    try {
      const res  = await fetch(`${API_URL}/support/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: loginUsername, password: loginPassword }),
      });
      const data = await res.json();
      if (data.success && data.support && data.token) {
        sessionStorage.setItem(TOKEN_KEY, data.token);
        sessionStorage.setItem(USER_KEY, loginUsername);
        setToken(data.token);
        setLoggedInAs(loginUsername);
        setLoginPassword('');
      } else {
        setLoginError('Access denied. Support credentials required.');
      }
    } catch { setLoginError('Connection failed. Please try again.'); }
    finally  { setSigningIn(false); }
  };

  const handleLogout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    setToken(null);
    setLoggedInAs('');
    setActiveTab('stats');
    setLoginUsername(''); setLoginPassword('');
  };

  // Passed to every tab; a 401 from any request forces re-login.
  const onAuthFail = () => { setLoginError('Session expired. Please sign in again.'); handleLogout(); };

  // ── login screen ──────────────────────────────────────────────────────────
  if (!token) {
    return (
      <div className="support-portal">
        <div className="sp-login-wrapper">
          <img className="sp-logo" src={logo} alt="Logo" />
          <h1>avCloudConnect</h1>
          <h2>Support Portal</h2>
          <form className="sp-login-form" onSubmit={handleLogin}>
            <input type="text"     placeholder="Support or Admin Username" value={loginUsername} onChange={e => setLoginUsername(e.target.value)} autoComplete="username" />
            <input type="password" placeholder="Password"                  value={loginPassword} onChange={e => setLoginPassword(e.target.value)} autoComplete="current-password" />
            {loginError && <p className="sp-login-error">{loginError}</p>}
            <button type="submit" disabled={signingIn}>{signingIn ? 'Signing in…' : 'Sign In'}</button>
          </form>
          <p className="sp-readonly-note">Support & admin credentials · read-only views</p>
        </div>
      </div>
    );
  }

  // ── authenticated shell ─────────────────────────────────────────────────────
  const tabProps = { token, onAuthFail };
  return (
    <div className="support-portal">
      <div className="sp-header">
        <img className="sp-logo-small" src={logo} alt="Logo" />
        <div className="sp-header-text">
          <h1>avCloudConnect</h1>
          <h2>Support Portal <span className="sp-readonly-badge">READ-ONLY</span></h2>
        </div>
        <div className="sp-tabs">
          {TABS.map(t => (
            <button key={t.key} className={`sp-tab-btn ${activeTab === t.key ? 'active' : ''}`} onClick={() => setActiveTab(t.key)}>
              {t.label}
            </button>
          ))}
        </div>
        <div className="sp-header-actions">
          {loggedInAs && <span className="sp-whoami">{loggedInAs}</span>}
          <button className="sp-btn sp-logout" onClick={handleLogout}>Logout</button>
        </div>
      </div>

      <div className="sp-content">
        {activeTab === 'stats'     && <StatsTab {...tabProps} />}
        {activeTab === 'customers' && <CustomersTab {...tabProps} />}
        {activeTab === 'serials'   && <SerialsTab {...tabProps} />}
        {activeTab === 'logs'      && <LogsTab {...tabProps} />}
        {activeTab === 'pocketreaderlogs' && <PocketReaderLogsTab {...tabProps} />}
        {activeTab === 'faq'       && <FaqTab {...tabProps} />}
      </div>
    </div>
  );
};

export default SupportPortal;
